export enum SECTION {
  INPUT_FEATURES = 'inputFeatures',
  INPUT_ABSICHERUNG = 'inputAbsicherung',
  INPUT_ALLGEMEIN = 'inputAllgemein',
  INPUT_BEITRAGSREDUZIERUNG = 'inputBeitragsreduzierung',
  INPUT_VN = 'inputVn',
  INPUT_VP = 'inputVp',
  INPUT_VORVERSICHERUNG = 'inputVorversicherung',
  INPUT_PREVIOUS_INSURANCE = 'inputPreviousInsurance',

  CONTRACT_COMPANY_QUESTION = 'contractCompanyQuestion',
  CONTRACT_BANK_TRANSFER_INFORMATION = 'contractBankTransferInformation',
  CONTRACT_CLIENT = 'contractClient',
  CONTRACT_CLIENT_VP = 'contractClientVP',
  CONTRACT_CLIENT_PERSONAL_INFORMATION = 'contractClientPersonalInformation',
  CONTRACT_CLIENT_ADDRESS_INFORMATION = 'contractClientAddressInformation',
  CONTRACT_CLIENT_CONTACT_INFORMATION = 'contractClientContactInformation',
  CONTRACT_CLIENT_OVERRIDE_CONFIRMATION = 'contractClientOverrideConfirmation',
  CONTRACT_COMPANY_CLIENT = 'contractCompanyClient',
  CONTRACT_COMPANY_NAME = 'contractCompanyName',
  CONTRACT_COMPANY_ADDRESS_INFORMATION = 'contractCompanyAddressInformation',
  CONTRACT_COMPANY_CONTACT_INFORMATION = 'contractCompanyContactInformation',
  CONTRACT_DOCUMENTS = 'contractDocuments',
  CONTRACT_MVP = 'contractMvp',
  CONTRACT_TARIFF_DETAILS = 'contractTariffDetails',
  CONTRACT_MEMO_BERATUNGSDOKUMENTATION = 'contractMemoBeratungsdokumentation',
  CONTRACT_PREVIOUS_INSURANCE_TERMINATION = 'contractPreviousInsuranceTermination',
  CONTRACT_ADDITIONAL_INFORMATION = 'contractAdditionalInformation',

  PROPERTY_CONTRACT_ADDITIONAL_INFORMATION = 'propertyContractAdditionalInformation',
  PROPERTY_PREVIOUS_DAMAGE = 'propertyPreviousDamage',
  PROPERTY_CONTRACT_ELEMENTARVERSICHERUNG = 'propertyContractElementarversicherung',
  PROPERTY_INSURED_OBJECT = 'propertyInsuredObject',
  PROPERTY_INPUT_PREVIOUS_DAMAGE = 'propertyInputPreviousDamage',
  PROPERTY_INPUT_RISIKOORT = 'propertyInputRisikoort',
  PROPERTY_CONTRACT_PREVIOUS_INSURANCE = 'propertyContractPreviousInsurance',

  WOH_PREVIOUS_DAMAGE = 'wohPreviousDamage',
  WOH_ADDITIONAL_INFORMATION_INSURED_OBJECT = 'wohAdditionalInformationInsuredObject',
  WOH_INPUT_SANIERUNG = 'wohInputSanierung',
  WOH_INPUT_RISIKOORT_ADDRESS = 'wohInputRisikoortAddress',
  WOH_INPUT_RISIKOORT_BUILDING = 'wohInputRisikoortBuilding',
  WOH_INPUT_RISIKOORT_SPACE = 'wohInputRisikoortSpace',
  WOH_INPUT_RISIKOORT_SPECIAL = 'wohInputRisikoortSpecial',
  WOH_INPUT_ABSICHERUNG_VERSICHERUNGSSUMME = 'wohInputAbsicherungVersicherungssumme',
  WOH_INPUT_ABSICHERUNG_RAHMENBEDINGUNGEN = 'wohInputAbsicherungRahmenbedingungen',
  WOH_INPUT_ABSICHERUNG_LEISTUNGSUMFANG = 'wohInputAbsicherungLeistungsumfang',
  WOH_INPUT_ABSICHERUNG_ABLEITUNGSROHRE = 'wohInputAbsicherungAbleitungsrohre',
  WOH_INPUT_ABSICHERUNG_PHOTOVOLTAIK = 'wohInputAbsicherungPhotovoltaik',

  HUN_INPUT_DOGS = 'hunInputDogs',
  HUN_INPUT_DOG = 'hunInputDog',
  HUN_CONTRACT_DOGS = 'hunContractDogs',

  RES_PREVIOUS_DAMAGE = 'resPreviousDamage',
  RES_CONTRACT_ADDITIONAL_INFORMATION_GENERIC = 'resContractAdditionalInformationGeneric',
  RES_CONTRACT_ADDITIONAL_INFORMATION_RENT = 'resContractAdditionalInformationRent',
  RES_CONTRACT_ADDITIONAL_INFORMATION_RENTAL = 'resContractAdditionalInformationRental',
  RES_CONTRACT_ADDITIONAL_INFORMATION_RENTAL_OBJECT = 'resContractAdditionalInformationRentalObject',
  RES_CONTRACT_ADDITIONAL_INFORMATION_TRAFFIC = 'resContractAdditionalInformationTraffic',
  RES_CONTRACT_ADDITIONAL_INFORMATION_TRAFFIC_CAR = 'resContractAdditionalInformationTrafficCar',
  RES_INPUT_LEISTUNGSUMFANG = 'resInputLeistungsumfang',
  RES_INPUT_RAHMENBEDINGUNGEN = 'resInputRahmenbedingungen',

  PFE_CONTRACT_HORSES = 'pfeContractHorses',
  PFE_CONTRACT_HORSE = 'pfeContractHorse',
  PFE_CONTRACT_VEREIN = 'pfeContractVerein',
  PFE_CONTRACT_REITBETEILIGUNGEN = 'pfeContractReitbeteiligungen',
  PFE_CONTRACT_REITBETEILIGUNG = 'pfeContractReitbeteiligung',

  PHV_DIENSTHAFTPFLICHT = 'phvDiensthaftpflicht',

  PKV_INPUT_GKV = 'pkvInputGkv',
  PKV_INPUT_AMBULANT_SELECT = 'pkvInputAmbulantSelect',
  PKV_INPUT_AMBULANT = 'pkvInputAmbulant',
  PKV_INPUT_AUSLANDSKRANKENVERSICHERUNG = 'pkvInputAuslandskrankenversicherung',
  PKV_INPUT_GRUNDBAUSTEINE = 'pkvInputGrundbausteine',
  PKV_INPUT_KRANKENHAUSTAGEGELD = 'pkvInputKrankenhaustagegeld',
  PKV_INPUT_KRANKENTAGEGELD = 'pkvInputKrankentagegeld',
  PKV_INPUT_PFLEGEPFLICHTVERSICHERUNG = 'pkvInputPflegepflichtversicherung',
  PKV_INPUT_PFLEGETAGEGELD = 'pkvInputPflegetagegeld',
  PKV_INPUT_STATIONAER = 'pkvInputStationaer',
  PKV_INPUT_ZAHN = 'pkvInputZahn',
  PKV_INPUT_BAUSTEINE = 'pkvInputBausteine',

  KFZ_CREDIT_ASSESSMENT = 'kfzCreditAssessment',
  KFZ_PREVIOUS_INSURANCE = 'kfzPreviousInsurance',
  KFZ_INPUT_CAR = 'kfzInputCar',
  KFZ_CONTRACT_CAR = 'kfzContractCar',
  KFZ_CONTRACT_CAR_EXTENDED = 'kfzContractCarExtended',
  KFZ_INPUT_FIRST_CAR = 'kfzInputFirstCar',
  KFZ_CONTRACT_FIRST_CAR = 'kfzContractFirstCar',
  KFZ_CONTRACT_PREVIOUS_CAR = 'kfzContractPreviousCar',
  KFZ_VN = 'kfzVn',
  KFZ_VERBAENDE = 'kfzVerbaende',
  KFZ_AUTOMOBILCLUBS = 'kfzAutomobilclubs',
  KFZ_INPUT_FAHRERKREIS = 'kfzInputFahrerkreis',
  KFZ_CONTRACT_FAHRERKREIS = 'kfzContractFahrerkreis',
  KFZ_INPUT_FAHRER = 'kfzInputFahrer',
  KFZ_CONTRACT_FAHRER = 'kfzContractFahrer',
  KFZ_FAHRERKREIS_ALTER = 'kfzFahrerkreisAlter',
  KFZ_FAHRER_ADD = 'kfzFahrerAdd',
  KFZ_EVB = 'kfzEvb',
  KFZ_CONTRACT_ABWEICHENDERHALTER = 'kfzContractAbweichenderhalter',
  KFZ_INPUT_ABWEICHENDERHALTER = 'kfzInputAbweichenderhalter',

  PROVIDENT_ADDITIONAL_SELECTION = 'providentAdditionalSelection',

  RLV_INPUT_ADDITIONAL_BEITRAGSREDUZIERUNG = 'rlvInputAdditionalBeitragsreduzierung',

  UNF_ADDITIONAL_INSURANCE = 'unfAdditionalInsurance',
  UNF_CONTRACT_SEE_AGREEMENT = 'unfContractSeeAgreement',
  UNF_CONTRACT_VP_INPUT = 'unfContractVpInput',
  UNF_INPUT_VP_LEISTUNGSUMFANG = 'unfInputVpLeistungsumfang',
  UNF_CONTRACT_ADDITIONAL_INFORMATION = 'unfContractAdditionalInformation',
  UNF_CONTRACT_VP_ADDITIONAL_INFORMATION = 'unfContractVpAdditionalInformation',
  UNF_INPUT_VP_PERSONAL_INFORMATION = 'unfInputVpPersonalInformation',

  COMPLETION = 'completion',
  DISTRIBUTION_SELECTION = 'distributionSelection',
  PROFILE_BAR = 'profileBar',

  RDE_HELP_INPUT = 'rdeHelpInput',
}
